import { isArray, isEmpty } from 'lodash-es'

export default function(contact) {
  let phone = null
  let phoneKey = null

  if (isArray(contact.companyRolodexContactPhones) && !isEmpty(contact.companyRolodexContactPhones)) {
    phoneKey = contact.companyRolodexContactPhones[0].companyRolodexContactPhoneKey
  }

  if (contact.phone) {
    phone = [
      {
        companyRolodexContactPhoneKey: phoneKey,
        companyRolodexContactPhoneDigits: contact.phone,
        companyRolodexContactPhonePrimaryFlag: true,
        companyRolodexContactPhoneType: 'n/a'
      }
    ]
  }

  return {
    ...contact,
    companyRolodexContactEmailAddress: contact.email,
    companyRolodexContactFullName: contact.name,
    companyRolodexContactPhones: phone
  }
}
